"use client";

if (typeof window !== "undefined" && window.customElements) {
  const _def = window.customElements.define;
  window.customElements.define = function (name, constructor, options) {
    if (!window.customElements.get(name)) {
      try {
        _def.call(window.customElements, name, constructor, options);
      } catch {}
    }
  };
}

export function CustomElementsGuard() {
  return null;
}
